<template>
  <div>
    <div 
      :class="[
        'flex justify-between items-center pl-3 pr-4 cursor-pointer discount-panel-card',
        addOnGreyOutBundle ? 'add-on-discount-panel' : '',
        { 'not-allowed-bg': !isAllowedForPatientAge },
        ]"
      @click="handleClick(bundle)"
    >
      <div class="flex items-center">
        <span v-if="!bundle[selectProp]" class="material-icons-outlined uncheck-box">
          check_box_outline_blank
        </span>
        <img v-else src="@/assets/orderTest/Checkbox(all).svg" alt="checked icon">
        <p class="ml-3">{{ getItemNameByLanguage(bundle) }}</p>
      </div>
      <a v-if="bundle.weblink" :href="bundle.weblink" target="_blank" class="ml-1">
        <span class="material-icons-outlined insert-link-icon">
          insert_link
        </span>
      </a>
      <div v-else class="flex items-center cursor-default" @click.stop>
        <img 
          v-if="bundle.isHotIcon" 
          src="@/assets/orderTest/order-page/order-test-panel/trending-topic.svg" 
          alt="hot icon" 
          class="mr-2" 
        />
        <PanelInfoPopover
          :panel-id="bundle.bundleId"
          :panel-name="bundle.bundleName"
          :price="bundle.price"
          :original-price="bundle.originalPrice"
          :panel-test-name-list="panelTestNameList"
        />
      </div>
    </div>
    <!-- xChooseY panel dialog -->
     <div v-if="bundle.category === 'xChooseY' && bundle.isOpenXChooseYDialog">
      <ThreeFor700Dialog
        v-if="[2,3,4,5].includes(bundle.bundleId)"
        :is-show-dialog="bundle.isOpenXChooseYDialog"
        :title="bundle.bundleName"
        :width="970"
        :id="bundle.bundleId"
        :quantity="5"
        :promo-price="bundle.finalAmount"
        show-deal-alert
        @close="closeDialog(bundle)"
        @isAddToCart="addAnyThreeAnyFivePanel(bundle, $event)"
      />
      <XChooseYDialog
        v-else
        :is-show-dialog="bundle.isOpenXChooseYDialog"
        :title="bundle.bundleName"
        :select-prop="selectProp"
        :is-show-choose-later="selectProp !== 'isSelect'"
        choose-text="Select zoomers: "
        is-not-allowed-select-prop="isNotAllowedSelectForXChooseY"
        :test-list="bundle.zoomerList"
        :test-quantity="bundle.quantity"
        :supplementList="bundle.supplementList"
        :supplementQuantity="bundle.supplementQuantity"
        @close="closeDialog(bundle)"
        @handleDone="addXChooseYPanel(bundle, $event)"
      >
        <template #choose-later-text>
          <p>choose zoomer <span class="font-bold">later</span>:</p>
        </template>
      </XChooseYDialog>
     </div>
    <ItemNotAllowedDialog 
      :is-show-dialog="isShowNotAllowedDialog"
      :item-category="bundle.category"
      :item-name="bundle.bundleName"
      dialog-type="notAllowedForPatientAge"
      @close="isShowNotAllowedDialog = false"
    />
    <AddOnUnableSelectDialog 
      :is-show-dialog="addOnUnableSelectDialogVisible" 
      :test-name="bundle.bundleName" 
      :unable-select-reason="addOnUnableSelectReason" 
      @close="addOnUnableSelectDialogVisible = false"
    />
  </div>
</template>

<script>
import PanelInfoPopover from "../../PanelInfoPopover.vue";
import ThreeFor700Dialog from "@/views/va-orderTest/order-page/promo-panel/three-for-700-promo-dialog/index.vue";
import XChooseYDialog from "../../../../XChooseYDialog.vue";
import ItemNotAllowedDialog from "@/views/va-orderTest/order-page/ItemNotAllowedDialog.vue";
import { isItemAllowedForPatientAge } from "../../../../custom-panel/customPanelCard.js";
import { mapGetters, mapState } from 'vuex';
import { 
  addSelectedDiscountPanel, 
  removeSelectedDiscountPanel 
} from '@/utils/va-order-test/testAndPanelSelection/discountPanelSelection';
import { 
  addSelectedXChooseYPanel, 
  removeSelectedXChooseYPanel 
} from '@/utils/va-order-test/testAndPanelSelection/xChooseYPanelSelection.js';
import AddOnUnableSelectDialog from '../../AddOnUnableSelectDialog.vue'
import { addAnyThreeAnyFivePanelFrom3For700Dialog, preparePanelForXChooseYDialog, addXChooseYPanelFromXChooseYDialog } from "./discountPanelCard.js";
import { getItemNameByLanguage } from "../../testCard.js";

export default {
  components: {
    PanelInfoPopover,
    ThreeFor700Dialog,
    XChooseYDialog,
    ItemNotAllowedDialog,
    AddOnUnableSelectDialog
  },
  props: {
    bundle: {
      type: Object,
      default: () => {}
    },
    selectProp: {
      type: String,
      default: "isSelect"
    },
    orderTestSupportObj: {
      type: Object,
      default: () => {}
    },    
  },

  data() {
    return {
      xChooseYBundle: this.bundle,
      currentSelectedCustomPanel: {},
      isVisible: false,
      xChooseYPanelList: [],
      isShowNotAllowedDialog: false,
      addOnUnableSelectDialogVisible: false,
      addOnUnableSelectReason: "Already Ordered"
    };
  },

  computed: {
    ...mapState(["language"]),
    ...mapState("orderTest", ["dbsMap","isAddOnOrder","addOnFixedDiscountPanel", "addOnRequiredMoreNoOfTubesTests", "addOnExpiredTestList"]),
    ...mapState("orderTest/panels", ["discountPanelList"]),
    ...mapGetters("orderTest/tests", ["testList"]),
    ...mapGetters("orderTest/panels", ["bundleList"]),
    ...mapGetters("orderTest/order", ["patientAge"]),
    addOnGreyOutBundle() {
      return this.addOnRequiredMoreNoOfTubesTests.map(i => i.id).filter(x => this.bundle.testIdsInPanel.includes(x)).length > 0 || 
        this.addOnExpiredTestList.filter(x => this.bundle.testIdsInPanel.includes(x)).length > 0
    },

    // get test names in current panel
    panelTestNameList() {
      let nameList = [];
      nameList = this.testList
        .filter(test => this.bundle.testIdsInPanel.includes(test.id))
        .map(test => getItemNameByLanguage(test, this.language));
      return nameList;
    },
    isAllowedForPatientAge() {
      return isItemAllowedForPatientAge(this.bundle, this.orderTestSupportObj, this.patientAge);
    }
  },

  methods: {
    handleClick(bundle) {
      if (!this.isAllowedForPatientAge) {
        this.isShowNotAllowedDialog = true;
        return;
      }
      if(this.isAddOnOrder.length > 0) {
        if(this.addOnFixedDiscountPanel.has(this.bundle.bundleId)) {
          this.addOnUnableSelectDialogVisible = true
          this.addOnUnableSelectReason = "Already Ordered"
          return 
        }
        if(this.addOnRequiredMoreNoOfTubesTests.map(i => i.id).filter(x => this.bundle.testIdsInPanel.includes(x)).length > 0 || 
          this.addOnExpiredTestList.filter(x => this.bundle.testIdsInPanel.includes(x)).length > 0
          ) {
          this.addOnUnableSelectDialogVisible = true
          this.addOnUnableSelectReason = "Requires New Kit"
          return 
        }
      }
      if (bundle.category === "discountPanel") {
        if(bundle[this.selectProp]) {
          removeSelectedDiscountPanel(bundle.bundleId, this.selectProp, this.orderTestSupportObj)
          this.$store.dispatch("orderTest/addOnFixedVaVwTestTubeInfo", {root:this.bundle,isFixedVaVw:'false',isSelect:'false'}) 
          if(this.isAddOnOrder.length > 0 && this.addOnFixedDiscountPanel.size !== 0) {
            let { packageList,testList } = bundle.bundleContent
            let testIdList = testList ? testList.map(t => t.testId) : [];
            let packageIdList = packageList ? packageList.map(p => p.packageId) : [];
            let bundleContentTesetIds = testIdList.concat(packageIdList)
            // if the removed bundle contains any test from tests from add on bundle
            // then add back affected add on bundle
            for (let key of this.addOnFixedDiscountPanel.keys()) {
              if(this.addOnFixedDiscountPanel.get(key).some(x => bundleContentTesetIds.includes(x))) {
                addSelectedDiscountPanel(key, this.selectProp, this.orderTestSupportObj);
              }
            }       
          }
        } else {
          addSelectedDiscountPanel(bundle.bundleId, this.selectProp, this.orderTestSupportObj);
          this.$store.dispatch("orderTest/addOnFixedVaVwTestTubeInfo", {root:this.bundle,isFixedVaVw:'false',isSelect:'true'}) 
        }
      }
      else {
        if (!bundle[this.selectProp]) {
          bundle.isOpenXChooseYDialog = true;
          preparePanelForXChooseYDialog(bundle, this.testList, this.bundleList, this.orderTestSupportObj); 
          return;
        }
        else {
          removeSelectedXChooseYPanel(bundle.bundleId, this.selectProp, this.orderTestSupportObj);
          // if the removed x choose y contains any test from tests from add on x choose y
          // then add back affected x choose y
          for (let key of this.addOnFixedDiscountPanel.keys()) {
            if(this.addOnFixedDiscountPanel.get(key)
              .some(x => bundle.selectedSupplementIdList.concat(bundle.selectedZoomerIdList).includes(x))) {
                addSelectedXChooseYPanel(key, this.selectProp, this.orderTestSupportObj);
            }
          }    
        }
      }
    },

    addXChooseYPanel(panel, selectedItems) {
      addXChooseYPanelFromXChooseYDialog(panel, selectedItems, this.selectProp, this.orderTestSupportObj);
      panel.isOpenXChooseYDialog = false;
    },
    
    closeDialog(panel) {
      panel.isOpenXChooseYDialog=false;
    },

    addAnyThreeAnyFivePanel(panel, payload) {
      addAnyThreeAnyFivePanelFrom3For700Dialog(payload, this.orderTestSupportObj);
      panel.isOpenXChooseYDialog = false;
    },

    getItemNameByLanguage(item) {
      return getItemNameByLanguage(item, this.language);
    }
  },
};
</script>

<style scoped>
.discount-panel-card {
  height: 46px;
  background: #F9FBFD;
  box-shadow: 0px 2px 6px rgba(48, 48, 48, 0.13);
  border-radius: 3.23482px;
  font-weight: 600;
  font-size: 15px;
  line-height: 18px;
  letter-spacing: 0.15px;
  color: rgba(0, 0, 0, 0.87);
}

.uncheck-box {
  font-size: 20px;
}

.add-on-discount-panel{
  background-color: #f2f2f2;
}

.not-allowed-bg {
  background-color: #f2f2f2;
}

.insert-link-icon {
  color: #3498DB;
  font-size: 14px;
}
</style>
